module.exports = __webpack_public_path__ + "img/shopBjpass.a7e7f443.png";